module.exports = __webpack_public_path__ + "img/page-05.c854887f.jpg";